<template>
  <div data-test-id="MenuComponent">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand data-test-id="home-link" to="/">
        <img class="menu-image" src="../assets/MenuIcon.png" height="50px" alt="Redbird" />
      </b-navbar-brand>

      <b-navbar-toggle v-if="user" target="nav-collapse" />

      <b-collapse v-if="user" id="nav-collapse" is-nav>
        <b-navbar-nav class="mr-auto ml-2">
          <b-nav-item v-if="selectedEMSAgency" data-test-id="cases-link" to="/cases" @click="nav('Cases')">
            Cases
          </b-nav-item>
          <b-nav-item
            v-if="selectedEMSAgency && isAdmin"
            data-test-id="trucks-link"
            to="/trucks"
            @click="nav('Trucks')"
          >
            Trucks
          </b-nav-item>
          <b-nav-item v-if="selectedEMSAgency && isAdmin" data-test-id="users-link" to="/users" @click="nav('Users')">
            Users
          </b-nav-item>
          <b-nav-item
            v-if="selectedEMSAgency && isAdmin"
            data-test-id="broadcast-messages-link"
            to="/broadcast-messages"
            @click="nav('Messages')"
          >
            Broadcast Messages
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="mr-auto ml-2">
          <AgencySelector
            :ems-agencies="EMSAgencies"
            :selected-ems-agency="selectedEMSAgency"
            @agencySelected="onAgencySelected"
          />
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-5">
          <b-nav-item target="Twiage Help" @click="open">
            Feedback
          </b-nav-item>
          <b-nav-item-dropdown id="menu__user-dropdown" right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{ user.displayName }}</em>
            </template>
            <b-dropdown-item disabled> Version {{ appVersion }} </b-dropdown-item>
            <b-dropdown-item id="menu__logout" data-test-id="sign-out" @click="logout">
              Sign Out
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item target="Twiage Help" :href="helpUrl" data-test-id="help-link" @click="nav('Help')">
            Help
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import get from "lodash.get";
import { mapState, mapActions, mapGetters } from "vuex";
import { LoggerService as lgg } from "vue-components-library";
import config from "@/App/config";
import { version } from "../../../package";
import AgencySelector from "./AgencySelector";

const LOG_TAG = "[MENU]";

export default {
  name: "Menu",
  components: { AgencySelector },
  data() {
    return {
      page: null
    };
  },
  computed: {
    ...mapState({
      user: state => get(state, "Login.user")
    }),
    ...mapGetters("Login", ["EMSAgencies", "selectedEMSAgency", "isAdmin"]),
    appVersion() {
      return version;
    },
    helpUrl() {
      return config.HELP_URL;
    }
  },
  methods: {
    ...mapActions("Login", ["logout", "setSelectedEMSAgency"]),
    ...mapActions("Feedback", ["open"]),

    onAgencySelected(agency) {
      this.setSelectedEMSAgency(agency);
    },

    nav(destination) {
      if (destination !== this.page) {
        lgg.info(`${LOG_TAG} Nav to ${destination}`);
      }
      this.page = destination;
    }
  }
};
</script>

<style scoped>
.bg-info {
  background-color: #981b1e !important;
}
.menu-image {
  margin-top: -8px;
  margin-bottom: -8px;
}
</style>
